module.exports = __webpack_public_path__ + "static/media/online.50051185.svg";